import { useContext } from 'react'
import HierarchyItemsTableContext from '../contexts/hierarchy-items-table-context'

const useHierarchyItemTableContext = () => useContext(HierarchyItemsTableContext)

export default useHierarchyItemTableContext
